// extracted by mini-css-extract-plugin
export default {"button":"wp-z","reviewSort":"xp-z"};